module.exports = __webpack_public_path__ + "static/media/wallet-icon.36a234e6.svg";